/**
 * Minimal HTML sanitizer for article body (TinyMCE output).
 * Allows only safe inline/block tags; strips script, style, etc.
 */

const ALLOWED_TAGS = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'a',
  'ul',
  'ol',
  'li',
  'h2',
  'h3',
  'blockquote',
])

export function sanitizeArticleHtml(html: string): string {
  if (!html?.trim()) return ''
  const doc = new DOMParser().parseFromString(html, 'text/html')
  const walk = (node: Node): string => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? ''
    if (node.nodeType !== Node.ELEMENT_NODE) return ''
    const el = node as Element
    const tag = el.tagName.toLowerCase()
    if (!ALLOWED_TAGS.has(tag)) return Array.from(node.childNodes).map(walk).join('')
    const attrs: string[] = []
    if (tag === 'a' && el.getAttribute('href')) {
      const href = el.getAttribute('href') ?? ''
      if (/^https?:\/\//i.test(href) || href.startsWith('/')) {
        attrs.push(`href="${href.replace(/"/g, '&quot;')}"`)
      }
    }
    const inner = Array.from(node.childNodes).map(walk).join('')
    const open = `<${tag}${attrs.length ? ' ' + attrs.join(' ') : ''}>`
    if (['br'].includes(tag)) return open
    return `${open}${inner}</${tag}>`
  }
  const body = doc.body
  return Array.from(body.childNodes).map(walk).join('')
}

export function looksLikeHtml(s: string): boolean {
  return /<[a-z][\s\S]*>/i.test(s ?? '')
}
